import React from 'react';

import { IWidgetBlockComponent } from '../types/IWidgetBlock';
import { Container } from './ImageFeed.style';
import { ImageFeedModel } from './types';

const ImageFeed: React.FC<IWidgetBlockComponent<ImageFeedModel>> = ({ widgetModel }) => {
    if (!widgetModel) {
        return null;
    }

    const { datasets } = widgetModel;
    const data = datasets?.[0]?.data;

    if (!data) {
        return <div>No image feed has been set up</div>;
    }

    return <Container className='imageFeedRender' bgImageUrl={data} />;
};

export default ImageFeed;
